import React from "react";
import Link from "next/link";

const Pager = ({
  to,
  value,
  active,
}: {
  to: string;
  value: React.ReactNode;
  active?: boolean;
}) => (
  <li className={`page-item ${active ? "active" : ""}`}>
    <Link href={to} className="page-link">
      {value}
    </Link>
  </li>
);

export default Pager;
